import React from 'react';

import MadAds2024  from 'views/MadAds2024';

const LogisticsPage = () => {
  return <MadAds2024 />;
};

export default LogisticsPage;
